<template>
  <div>

    <AppInfoEmailQualisoftRaw
      :email-raw-decoded="emailRawDecoded"
    />

    <AppInfoEmailQualisoftCarimboTempo
      :carimbo-email="carimboEmail"
    />

    <AppInfoEmailQualisoftSendDetails
      :carimbo-email-envio="carimboEmailEnvio"
    />

    <AppInfoEmailQualisoftDeliveryDetails
      :carimbo-email-entregue="carimboEmailEntregue"
    />

  </div>
</template>
<script>
import AppInfoEmailQualisoftRaw from './InfoEmailQualisoftRaw'
import AppInfoEmailQualisoftCarimboTempo from './InfoEmailQualisoftCarimboTempo'
import AppInfoEmailQualisoftSendDetails from './InfoEmailQualisoftSendDetails'
import AppInfoEmailQualisoftDeliveryDetails from './InfoEmailQualisoftDeliveryDetails'
export default {
  name: 'AppInfoEmailQualisoft',

  components: {
    AppInfoEmailQualisoftRaw,
    AppInfoEmailQualisoftCarimboTempo,
    AppInfoEmailQualisoftSendDetails,
    AppInfoEmailQualisoftDeliveryDetails
  },

  props: {
    emailRawDecoded: {
      type: String
    },
    carimboEmail: {
      type: Object
    },
    carimboEmailEnvio: {
      type: Object
    },
    carimboEmailEntregue: {
      type: Object
    }
  },

  computed: {
    showTabCarimboEmail () {
      return Object.keys(this.carimboEmail).length
    },
    showTabCarimboEmailEnvio () {
      return Object.keys(this.carimboEmailEnvio).length
    },
    showTabCarimboEmailEntregue () {
      return Object.keys(this.carimboEmailEntregue).length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/provider-qualisoft/InfoEmailQualisoft.vue